'use strict';

const { showToastMessage } = require('../../js/components/toast');

module.exports = function (element, message, id) {
    showToastMessage({
        containerSelector: element,
        message: message,
        alertType: 'alert-danger',
        alertQa: 'alert-danger-dismissable',
        alertId: id,
        disableAutoClosing: true
    });
};
